// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"bde9f0b0","132":"15752421","648":"6ac28f5c","787":"ec6d01a1","954":"978e05df"}[chunkId] + ".chunk.js";
};